module.exports = __webpack_public_path__ + "img/cww_07.c0736621.jpg";